import { Injectable, EventEmitter  } from '@angular/core';

@Injectable()
export class UserService {
  $userChanges = new EventEmitter<any>();
  constructor() { }

      public setItem(key, item) {
          // what ever u where doing , plus :
          localStorage.setItem(key, item);
          this.$userChanges.emit(item);
      }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/authentication/services/user.service.ts